import React from "react";
import { Col, Input, Form, Select, Radio } from "antd";
import { checkAlphabets } from "../../../utils";
import PincodeValidator from "../../../components/PincodeValidator";

import AutoCompleteAddress from "../../FirstMile/CrediteBooking/AutoCompleteAddress";

export const CPDetails = ({ getData }) => {
  const [form] = Form.useForm();

  const businessModel = [
    {
      label: "Company Owned Company Operated",
      value: "COCO",
    },
    {
      label: "Franchise Owned Franchise Operated",
      value: "FOFO",
    },
    {
      label: "Franchise Owned Company Operated",
      value: "FOCO",
    },
  ];
  return (
    <>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          name="orgName"
          label="CP name"
          rules={[
            {
              required: true,
              message: "Please enter CP name",
            },
          ]}
          onKeyPress={(event) => {
            if (checkAlphabets(event)) {
              event.preventDefault();
            }
          }}
        >
          <Input
            placeholder="Enter CP name"
            disabled={getData?.status?.toLowerCase() === "approved"}
            // disabled={getData ? true : false}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          name="cpType"
          label="CP type"
          rules={[
            {
              required: true,
              message: "Please select CP type",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Please select CP type"
            options={[
              {
                value: "Booking",
                label: "Booking",
              },
            ]}
            disabled={getData?.status?.toLowerCase() === "approved"}
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          name="businessFlag"
          label="Business Mode"
          rules={[{ required: true, message: "Please select business mode" }]}
        >
          <Select
            placeholder="Select Business Mode"
            options={businessModel}
            disabled={getData?.status?.toLowerCase() === "approved"}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <PincodeValidator
          formName="pincode"
          value={getData?.basicDetail?.pincode}
          disabled={getData?.status?.toLowerCase() === "approved"}
        />
      </Col>
      <Col span={12}>
        <Form.Item
          name="dropRadius"
          label="Allowed Drop Radius"
          rules={[
            {
              required: true,
              message: "Select drop radius",
            },
          ]}
        >
          <Radio.Group disabled={getData?.status?.toLowerCase() === "approved"}>
            <Radio value="City">City</Radio>
            <Radio value="State">State</Radio>
            <Radio value="PAN India">PAN India</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        {getData?.status?.toLowerCase() === "approved" ? (
          <Form.Item name="street" label="Address line 1">
            <Input
              placeholder="Enter address line1"
              disabled={getData?.status?.toLowerCase() === "approved"}
              // disabled={getData ? true : false}
            />
          </Form.Item>
        ) : (
          <AutoCompleteAddress
            form={form}
            returnAddress={false}
            alertData={null}
            fieldName="street"
            label="Address line 1"
            rules={[
              {
                required: true,
                message: "Enter address line 1",
              },
            ]}
          />
        )}
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item name="area" label="Address line 2">
          <Input
            placeholder="Enter house no, building, street"
            disabled={getData?.status?.toLowerCase() === "approved"}
            // disabled={getData ? true : false}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default CPDetails;
